import { IrisEnabledBanner } from '#~/device/components/iris-enabled-banner/index.js';
import { IrisDeviceCard } from '#~/device/components/iris-device-card/index.js';
import { useMultiProxyStateQuery } from '#~/statequery/hook.js';
import type { Agent } from '@studio/models/agent';
import { toVersion } from '@studio/models/agent';
import { useState, type ReactElement } from 'react';
import { twMerge } from 'cn';
import { MonitoringLite } from '../monitoring/summary-lite.jsx';
import { useStore } from '../store/hooks.js';
import { FirmwareStatus } from './firmware-status.js';

interface MonitoringContentProps {
  agent?: Agent | undefined;
  className?: string;
}

export const MonitoringContent = ({ agent, className }: MonitoringContentProps): ReactElement => {
  const candidate = useStore((µ) => µ.candidate);
  const agentId = useStore((µ) => µ.agentId);

  const proxyStateMap = useMultiProxyStateQuery<{
    encoderVersion: string | undefined;
  }>((state) => ({
    encoderVersion: state?.status?.encoder?.version
  }));

  const proxyState = proxyStateMap[agentId];
  const encoderVersion = proxyState?.encoderVersion;
  const isEmbeddedCamera = agent?.embedded ?? false;
  const [isBannerVisible, setIsBannerVisible] = useState(true);

  return (
    <div className={twMerge('flex flex-col gap-24', className)}>
      {isEmbeddedCamera && (
        <>
          <IrisEnabledBanner visible={isBannerVisible} onClose={() => setIsBannerVisible(false)} />
          <IrisDeviceCard
            sourceSelection={{
              name: candidate.name,
              modelId: candidate.modelId,
              ...(encoderVersion && { version: toVersion(encoderVersion) })
            }}
            size='large'
            variant='monitoring'
            showTooltip={false}
          />
          <FirmwareStatus agentId={agentId} deviceId={candidate.id} />
        </>
      )}
      <MonitoringLite agent={agent} className='w-full' />
    </div>
  );
};

MonitoringContent.displayName = 'MonitoringContent';
